import { UserInputError } from '../errors/UserInputError';
import { RowQuantityType } from '../lscript/row_types';
import {
  areaUnits,
  lengthUnits,
  massUnits,
  volumeUnits,
  timeUnits,
  calendarUnits,
  fuelEconomyUnits,
  temperatureUnits,
  textileUnits,
  energyUnits,
  powerUnits,
  currencyUnits,
  informationUnits,
  forceUnits,
  Unit,
  UnitGroup,
  unitToString,
  carbonUnits,
  countUnits,
} from '../unit';
import { activityTypeLegacyMapping } from './legacyMapping';
import { parseUnitString } from './parse';

const UNIT_GROUP_TO_UNITS = new Map<UnitGroup, Array<Unit>>([
  ['area', areaUnits],
  ['length', lengthUnits],
  ['mass', massUnits],
  ['volume', volumeUnits],
  ['time', timeUnits],
  ['calendar', calendarUnits],
  ['fuelEconomy', fuelEconomyUnits],
  ['temperature', temperatureUnits],
  ['textile', textileUnits],
  ['energy', energyUnits],
  ['power', powerUnits],
  ['count', countUnits],
  ['currency', currencyUnits],
  ['information', informationUnits],
  ['force', forceUnits],
  ['carbon', carbonUnits],
]);

// Get list of all units in a unitGroup such as all area units or all length units
// All units in the returned list are "compatible" meaning they can be directly
// converted between
export function getUnitsFromUnitGroup(unitGroup: UnitGroup): Array<Unit> {
  return UNIT_GROUP_TO_UNITS.get(unitGroup) ?? [parseUnitString('count')];
}

// inverse of above
export function getUnitGroupFromUnit(
  unit: Unit | undefined
): UnitGroup | undefined {
  if (unit) {
    for (const [unitGroup, unitList] of UNIT_GROUP_TO_UNITS) {
      if (unitList.includes(unit)) {
        return unitGroup;
      }
    }
  }
}

export function parseLegacyStringUnit(
  legacyUnit: string,
  activityType: string,
  columnName: string
): Unit {
  const newUnitString =
    activityTypeLegacyMapping[activityType]?.[columnName]?.[legacyUnit];

  if (!newUnitString) {
    throw new UserInputError(
      `Could not find mapping for legacy unit: ${activityType}, ${columnName}, ${legacyUnit}`
    );
  }

  return parseUnitString(newUnitString);
}

export function makeQuantityType(
  unitGroup: UnitGroup,
  unitCol: string
): RowQuantityType {
  const units = getUnitsFromUnitGroup(unitGroup);
  return {
    ty: 'quantity',
    units,
    encodedValuesToUnits: new Map(
      units.map((unit) => [unitToString(unit), unit])
    ),
    column: unitCol,
  };
}
